<template>
  <div class="input-radio">
    <input
      :id="compId"
      :name="name"
      type="radio"
      :value="inputValue"
      :checked="checked"
      @change="eventEmmiter"
    />
    <label :for="compId" class="input-radio--fake-radio"></label>
    <label :for="compId" class="input-radio--label">{{ label }}</label>
  </div>
</template>

<script>
/**
 * * Componente de input do tipo radio
 */
import { getRandomInt } from '@/helpers/math'

export default {
  name: 'InputRadio',
  props: {
    /** Id do input */
    id: {
      type: String,
      default: ''
    },
    /** Valor do input */
    inputValue: [String, Number, Object, Boolean],
    /** Nome do input */
    name: String,
    /** Label do input */
    label: String,
    /** Se está selecionado */
    checked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: this.checked,
      defaultId: `input-radio-${getRandomInt(0, 99999)}`
    }
  },
  computed: {
    compId() {
      return this.id || this.defaultId
    }
  },
  methods: {
    eventEmmiter() {
      this.$emit('input', this.inputValue)
      this.$emit('change', this.inputValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.input-radio {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;

  &--label {
    display: inline-block;
    margin: 0 0 0 8px;
    font-size: font-size('size-medium');
  }

  &--label,
  input {
    cursor: inherit;
  }

  &--fake-radio {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
    border-radius: 100%;
    border: 1px solid $gray-darkest;
    overflow: hidden;
    cursor: pointer;
  }

  input {
    display: none;

    &:checked ~ .input-radio--fake-radio {
      border-color: $primary;

      &:before {
        content: '';
        display: block;
        width: 8px;
        height: 8px;
        border-radius: 100%;
        background-color: $primary;
      }
    }
  }
}
</style>
